import React, { useMemo } from 'react';
import styled from 'styled-components';
import { shallowEqual, useSelector } from 'react-redux';
import { selectBoothById } from 'models/cms/booths';
import StyledContainer from './styled';
import GeneticDesignElement from './genericDesignElement';

const RootContainer = styled.div`
  position: relative;
  width: 1000px;
  margin: 0 auto;
`;

const CanvasContainer = styled(StyledContainer)<{ maxWidth: string; aspectRatio: string; positionX: string; positionY: string }>`
  position: relative;
  max-width: ${({ maxWidth }) => maxWidth};
  padding-top: ${({ aspectRatio }) => `${aspectRatio}`};
  left: ${({ positionX }) => positionX};
  top: ${({ positionY }) => positionY};
`;

const BoothDesignContainer = ({
  boothId,
  isPreview = false,
}: {
  boothId: string;
  isPreview: boolean;
}) => {
  const booth = useSelector((state) => selectBoothById(state as any, boothId), shallowEqual);
  const boothDesignCanvas = useMemo(() => booth.boothDesignCanvas, [booth.boothDesignCanvas]);
  const features = useSelector((s: any) => s.eventConfigs.features);
  const boothVideoAutoplay = useMemo(() => features.includes('boothVideoAutoplay'), [features]);

  if (!boothDesignCanvas) return null;

  const {
    maxWidth = '1200px', aspectRatio = '50%', width = '100%', height = '100%', positionX = '0', positionY = '0',
    layers = [],
  } = boothDesignCanvas;

  const aspectRatioNum = (100 / parseFloat(aspectRatio.replace('%', ''))) * 100;

  return (
    <RootContainer>
      <CanvasContainer maxWidth={maxWidth} aspectRatio={aspectRatio} width={width} height={height} positionX={positionX} positionY={positionY}>
        {
          layers.map((layer) => (
            <GeneticDesignElement
              layer={layer}
              boothId={boothId}
              key={layer.id}
              isPreview={isPreview}
              canvasAspectRatio={aspectRatioNum}
              boothVideoAutoplay={boothVideoAutoplay}
            />
          ))
        }
      </CanvasContainer>
    </RootContainer>
  );
};

export default React.memo(BoothDesignContainer);
